import React, { useCallback } from 'react';
import loginBtn from '../../../assets/ic_loginarrow.png';
import Header from '../../../components/Common/Header';
import Footer from '../../../components/Common/Footer';
import { formatNumber } from '../../../util/utility';

export type SenderDetail = {
    SenderName?: string;
    Maintenance?: string | number;
};

export type SubmitNumberProps = {
    senderDetail?: SenderDetail | null;
    phoneNumber: string;
    acceptTerms: boolean;
    errMsg: string;
    errMsgNum: string;
    handleChangePhoneNumber: (value: string) => void;
    submitNumberToGetOTP: () => void;
    acceptTermsAndCondition: () => void;
};

function SubmitNumber({
    senderDetail,
    phoneNumber,
    acceptTerms,
    errMsg,
    errMsgNum,
    handleChangePhoneNumber,
    submitNumberToGetOTP,
    acceptTermsAndCondition,
}: SubmitNumberProps) {
    const onChangePhone = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            const value = e.target.value.slice(0, 10);
            handleChangePhoneNumber(value);
        },
        [handleChangePhoneNumber]
    );

    const termsAndCondition = useCallback(() => {
        window.open('https://www.societynotebook.com/terms/TermsandConditions.html', '_blank');
    }, []);

    return (
        <div className="login-container-width main background">
            <Header />

            <div className="row Mb-2">
                <div className="col-sm-12 col-md-12 col-lg-12">
                    <h2 className="login-txt">Login</h2>
                </div>
            </div>

            <div className="row Mb-1">
                <div className="col-sm-12 col-md-12 col-lg-12">
                    <p className="justify">
                        {' '}
                        Help your friend <b>{senderDetail ? senderDetail.SenderName : ''} </b>
                        to decrease his society maintenance by{' '}
                        <b>{formatNumber(senderDetail ? senderDetail.Maintenance : '')}</b>
                    </p>
                </div>
            </div>

            <div className="row Mb-2">
                <div className="col-sm-12 col-md-12">
                    <input
                        className={errMsgNum ? 'borderEffect-Err' : 'borderEffect'}
                        name="Phone Number"
                        type="number"
                        inputMode="numeric"
                        max={10}
                        autoFocus
                        maxLength={10}
                        placeholder="+91(India) Mobile Number"
                        value={phoneNumber}
                        onChange={onChangePhone}
                    />
                    <span className="focus-border"></span>
                </div>
            </div>

            <div className="row errTxtRow">
                {errMsgNum !== '' ? <span className="errTxt">{errMsgNum}</span> : null}
            </div>

            <div className="row Mb-1 Mb-bottom">
                <div className="col-sm-12 col-md-12 col-lg-12">
                    <div>
                        <span>
                            <input
                                id="c1"
                                type="checkbox"
                                className="checkBoxErr"
                                checked={acceptTerms}
                                onClick={acceptTermsAndCondition}
                            />
                        </span>
                        <span className={errMsg !== '' ? 'blink terms' : 'terms'}>
                            Accept{' '}
                            <a onClick={termsAndCondition} target="_blank" rel="noreferrer">
                                Terms & Conditions
                            </a>
                        </span>
                    </div>
                </div>
            </div>

            <div className="row Mb-1">
                <div className="col-sm-12 col-md-12 col-lg-12 alignCen">
                    <img src={loginBtn} className="submitBtImage" onClick={submitNumberToGetOTP} alt="" />
                </div>
            </div>

            <Footer />
        </div>
    );
}

export default SubmitNumber;
